import React from "react";
import { useGetTeamQuery } from "../../../features/TeamMembers/TeamMembersApi";
import TeamMember from "./TeamMember";

const Team = () => {

    const {data:teamMembers , isError, isLoading} = useGetTeamQuery();
    
    // decide what to render
  let content = null;

  if (isLoading) {
    content = <div className="m-2 text-center">Loading...</div>;
  } else if (!isLoading && isError) {
    content = <div className="m-2 text-center">There was an error.</div>;
  } else if (!isLoading && !isError && teamMembers?.length === 0) {
    content = <div className="m-2 text-center">No conversations found!</div>;
  } else if (!isLoading && !isError && teamMembers?.length > 0) {
    content = teamMembers.map((teamMember) => (
        <TeamMember key={teamMember.id} teamMember={teamMember}></TeamMember>
    ));
  }


  return (
    <>
      <div className="mt-8">
        <h3 className="text-xl font-bold">Team Members</h3>
        <div className="mt-3 space-y-4">
          {content}
        </div>
      </div>
    </>
  );
};

export default Team;
